module.exports = __webpack_public_path__ + "img/py.991fbe97.svg";